import { Component, OnInit } from '@angular/core';
import { BasicModal } from '@shared/extender/basic-modal';
import { SharedModule } from '@shared/shared.module';
import { FormArray, FormBuilder, ReactiveFormsModule, UntypedFormGroup, Validators } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgToggleModule } from 'ng-toggle-button';
import { PatientDTO } from '@data/common/PatientDTO';
import { AssignPatientToTimelineFacadeService } from '@shared/service/assign-patient-to-timeline-facade.service';
import { ObjectUtil } from '@shared/util/object.util';
import { TreatmentStatus } from 'app/view/patients/data/TreatmentStatus';
import { AssignPatientToPsychologistsTimelineDTO } from '@domain/psychologist/data/AssignPatientToPsychologistsTimelineDTO';

@Component({
    selector: 'app-assign-patients-to-timeline-modal',
    standalone: true,
    imports: [
        SharedModule,
        ReactiveFormsModule,
        NgSelectModule,
        NgToggleModule
    ],
    templateUrl: './assign-patients-to-timeline-modal.component.html',
    styleUrl: './assign-patients-to-timeline-modal.component.scss'
})
export class AssignPatientsToTimelineModalComponent extends BasicModal<AssignPatientToPsychologistsTimelineDTO[]> implements OnInit {
  public readonly TreatmentStatus: typeof TreatmentStatus = TreatmentStatus;
  public patients: PatientDTO[];

  public treatmentStatusOptions = ObjectUtil.createEnumSelectOptions(TreatmentStatus, 'TREATMENT_STATUS');

  public sessionOptions = [];

  public form: UntypedFormGroup = this.fb.group({
    patients: this.fb.array([])
  });

  public get patientsControl(): FormArray {
    return this.form.get('patients') as FormArray;
  }

  constructor(private fb: FormBuilder, private assignPatientToTimelineFacadeService: AssignPatientToTimelineFacadeService) {
    super();
  }

  public ngOnInit(): void {
    this.initSessionOptions();
    this.renderFormRows();
  }

  public submit(): void {
    if (this.form.valid) {
      this.ok(this.createRequest())
    }
  }

  public skip(): void {
    this.assignPatientToTimelineFacadeService.skipPatientsAssignments().subscribe(() => {
      this.close();
    });
  }

  private createRequest(): AssignPatientToPsychologistsTimelineDTO[] {
    return this.patientsControl.controls.map(control => (
      {
        patientId: control.value.patientId,
        treatmentStatus: control.value.treatmentStatus,
        migratedTreatmentSessionNumber: control.value.treatmentStatus === TreatmentStatus.TREATMENT ? control.value.migratedTreatmentSessionNumber : null
      }
    ))
  }

  private initSessionOptions(): void {
    for (let i = 1; i <= 50; i++) {
      this.sessionOptions.push(
        {
          value: i,
          label: i < 10 ? `0${ i }` : i
        }
      )
    }
  }

  private renderFormRows(): void {
    this.patients.forEach(patient => {
      this.patientsControl.push(this.fb.group({
        fullName: [ `${ patient.firstName || '' } ${ patient.lastName || '' }`.trim() ],
        patientId: [ patient.id ],
        treatmentStatus: [ null, [ Validators.required ] ],
        migratedTreatmentSessionNumber: [ null ]
      }));
    });
  }
}
